import React from 'react';

const getAccessToken = () => {
   return localStorage.getItem('accessToken');
};

const isAuthenticated = () => {
    return !!localStorage.getItem('accessToken');
};

const login = () => {
    if (window.location.pathname !== '/login') {
     window.location.href = '/login';
    }
}

const logout = () => {
   localStorage.removeItem('accessToken');
  window.location.href = '/login'; 
};

export function withAuth(WrappedComponent) {

  const ComponentWithAuth = (props) => {
    const authHelpers = {
      getAccessToken,
      isAuthenticated,
      logout,
      login,
    };

    return <WrappedComponent {...props} auth={{...authHelpers}} />;
  };

  return ComponentWithAuth;
}
